import { isNotDefined } from '@sgme/fp';

import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { selectSwapTile } from '@/store/swap/selectors/tile.ts';
import { swapSlice } from '@/store/swap/slice.ts';
import { selectTab } from '@/store/tabs/selectors.ts';
import { tabsSlice } from '@/store/tabs/slice.ts';
import { selectTileIdsOfTab } from '@/store/workspace/selector.ts';

export const registerChangeClientListenersForSwap = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: tabsSlice.actions.changeClient,
    effect: async (action, api) => {
      const state = api.getState();

      const tab = selectTab(state, action.payload.tabId);

      if (isNotDefined(tab)) {
        return;
      }

      const allSwapIds = selectTileIdsOfTab(state, tab)
        .values()
        .filter((tileId) => selectSwapTile(state, tileId) !== undefined);

      for (const tileId of allSwapIds) {
        api.dispatch(
          swapSlice.actions.swapClientIdUpdated({
            tileId,
            clientId: action.payload.clientId,
            isTabClientOverriden: false,
          }),
        );
      }
    },
  });
};
